import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43df7a29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "list-name"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['tab-list-wrapper', _ctx.tabName === '品牌：' ? ' brand-list-wrapper ' : 'price-list-wrapper' ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.tabName === '品牌：' ? 'list-wrapper' : 'list-wrapper-p' ])
      }, [
        (_ctx.tabName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.tabName), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("div", {
            class: "scroll-wrapper",
            ref: "listRef",
            onTouchstart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.webViewModel(true))),
            onTouchmove: _cache[3] || (_cache[3] = ($event: any) => (_ctx.webViewModel(true))),
            onTouchend: _cache[4] || (_cache[4] = ($event: any) => (_ctx.webViewModel(false)))
          }, [
            _createElementVNode("div", {
              class: "list",
              onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  key: index,
                  class: _normalizeClass(
                              [
                                'item',
                                {'last-item': index == _ctx.list.length - 1},
                                {'unactive': _ctx.tabName === '价格：'&& index !== 0 && _ctx.associateTabIndex === 0}
                              ]),
                  style: _normalizeStyle({'color': index == _ctx.curTabIndex ? _ctx.activeColor : '#656565'}),
                  onClick: ($event: any) => (_ctx.changeTabItem(index, item))
                }, _toDisplayString(item.showName), 47, _hoisted_3))
              }), 128))
            ], 32)
          ], 544)
        ], true)
      ], 2)
    ], 2)
  ]))
}